/**
 * 会员模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取会员列表
export const memberList = (params) => {
  return req.get('/system/member/list', params);
}

// 根据患者id获取会员详情
export const memberInfo = (patientId) => {
  return req.get(`/system/member/getMemberByPatinetId/${patientId}`)
}

// 新增会员
export const memberAdd = (params) => {
  return req.post('/system/member', params);
}

// 修改会员信息
export const memberEdit = (params) => {
  return req.put('/system/member', params);
}

// 查询可退款充值记录
export const getUsableRechargeRecord = (params) => {
  return req.get('/member/wallet/recharge/getUsableRechargeRecord', params)
}
//手机号查询会员信息
export const getInfoByPhone = (params) => {
  return req.get('/system/member/get/phone', params)
}

// 查询订单至尊卡信息
export const getOrderVipCardInfo = (params) => {
  return req.get('/member/vipCard/queryOrderBindVipCardNumber', params)
}

// 查询至尊卡信息
export const getVipCardInfo = (params) => {
  return req.get('/member/vipCard/queryVipCard', params)
}

// 绑定至尊卡
export const bindVipCard = (params) => {
  return req.post('/member/vipCard/bindOrderVipCard', params)
}

// 绑定至尊卡
export const updateVipCardDiscount = (params) => {
  return req.post('/member/vipCard/updateBindOrderVipCardDiscountStatus', params)
}

// 解绑至尊卡
export const unBindVipCard = (params) => {
  return req.post('/member/vipCard/unBindOrderVipCard', params)
}

export const deleteMember = (memberId) => {
  return req.delete(`/user-block-list/delete/member/${memberId}`)
}